import { defineComponent } from 'vue';
import { MultiSelect } from '@studyportals/multiselect';
import { BudgetTypes } from '@/models/budget.interface';
import BudgetCode from '@/presentation/components/campaign-settings/budget/budget.code';

export default defineComponent({
	props: {
		type: {
			type: String,
			required: true
		}
	},
	components: {
		MultiSelect
	},
	setup: (props) => {
		const code = new BudgetCode(props.type as BudgetTypes);
		return {
			capitalisedType: code.capitalisedType,
			storedBudget: code.storedBudget,
			isFieldDisabled: code.isFieldDisabled,
			validationMessage: code.validationMessage,
			isFieldValidatedAndMissing: code.isFieldValidatedAndMissing,
			isFieldValidatedAndInvalid: code.isFieldValidatedAndInvalid,
			isBudgetTypeCustom: code.isBudgetTypeCustom,
			budgetLeft: code.budgetLeft,
			budgetTotal: code.budgetTotal,
			setBudgetBasedOnEvent: code.setBudgetBasedOnEvent.bind(code)
		};
	}
});
